export type ThemeName = string;

export const ThemeList = {
  DEFAULT: 'default',
  FOREST: 'forest-light',
  FOREST_DARK: 'forest-dark',
  RED: 'red-light',
  RED_DARK: 'red-dark',
  GREEN: 'green-light',
  GREEN_DARK: 'green-dark',
  CYAN: 'cyan-light',
  CYAN_DARK: 'cyan-dark',
  INDIGO: 'indigo-light',
  INDIGO_DARK: 'indigo-dark',
  SUNSET: 'sunset-light',
  SUNSET_DARK: 'sunset-dark',
  AMBER: 'amber-light',
  AMBER_DARK: 'amber-dark',
  ORANGE: 'orange-light',
  ORANGE_DARK: 'orange-dark',
  DEEP_ORANGE: 'deep-orange-light',
  DEEP_ORANGE_DARK: 'deep-orange-dark',
  BLUE_GRAY: 'blue-gray-light',
  BLUE_GRAY_DARK: 'blue-gray-dark',
  GRAY_LIGHT: 'gray-light',
  GRAY_DARK: 'gray-dark',
  PINK: 'pink-light',
  PINK_DARK: 'pink-dark',
  ROSE: 'rose-light',
  ROSE_DARK: 'rose-dark',
  PASTEL: 'pastel',
  PASTEL_DARK: 'pastel-dark',
  PASTEL_PINK: 'pastel-pink-light',
  PASTEL_PINK_DARK: 'pastel-pink-dark',
  BABY_BLUE: 'baby-blue-light',
  BABY_BLUE_DARK: 'baby-blue-dark',
  SAPHIRE_BLUE: 'sapphire-blue-light',
  SAPHIRE_BLUE_DARK: 'sapphire-blue-dark',
  EMERALD_GREEN: 'emerald-green-light',
  EMERALD_GREEN_DARK: 'emerald-green-dark',
  GOLD: 'gold-light',
  GOLD_DARK: 'gold-dark',
  GOLD_RUSH: 'gold-rush-light',
  GOLD_RUSH_DARK: 'gold-rush-dark',
  CHARCOAL: 'charcoal-gray-light',
  CHARCOAL_DARK: 'charcoal-gray-dark',
  VIOLET: 'violet-purple-light',
  VIOLET_DARK: 'violet-purple-dark',
  TEAL: 'teal-aqua-light',
  TEAL_DARK: 'teal-aqua-dark',
  FOREST_CAMO: 'forest-camo-light',
  FOREST_CAMO_DARK: 'forest-camo-dark',
  MIDNIGHT_STEEL: 'midnight-steel-light',
  MIDNIGHT_STEEL_DARK: 'midnight-steel-dark',
  ROSE_PINK: 'rose-pink-light',
  ROSE_PINK_DARK: 'rose-pink-dark',
  RUBY: 'ruby-red-light',
  RUBY_DARK: 'ruby-red-dark',
  LIME: 'lime-light',
  LIME_DARK: 'lime-dark',
  CRIMSON: 'crimson-light',
  CRIMSON_DARK: 'crimson-dark',
  METAL: 'metal-core-light',
  METAL_DARK: 'metal-core-dark',
  EXEC_BLACK: 'executive-black-light',
  EXEC_BLACK_DARK: 'executive-black-dark',
  COPPER: 'copper-light',
  COPPER_DARK: 'copper-dark',
  PLATINUM: 'platinum-light',
  PLATINUM_DARK: 'platinum-dark',
  ROYAL_PURPLE: 'royal-purple-light',
  ROTAL_PURPLE_DARK: 'royal-purple-dark',
  LAVENDER: 'lavender-light',
  LAVENDER_DARK: 'lavender-dark',
  OCEAN: 'ocean-blue-light',
  OCEAN_DARK: 'ocean-blue-dark',
  HIGH_CONTRAST_LIGHT: 'high-contrast-light',
  HIGH_CONTRAST_DARK: 'high-contrast-dark',
} as const;

export const ValidThemes = Object.values(ThemeList) as ThemeName[];
